export default __webpack_public_path__ + "static/media/portada_Panel02.e3150b5b.jpg";